function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudLayer = require('../hud-layer');
var PiracyTemplate = require('./piracy.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var PiracyOverlay = /*#__PURE__*/function () {
  function PiracyOverlay(app, mod) {
    _classCallCheck(this, PiracyOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod);
  }
  return _createClass(PiracyOverlay, [{
    key: "hide",
    value: function hide() {
      this.visible = false;
      this.overlay.hide();
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      HudLayer.pullHudOverOverlay.call(this);
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      HudLayer.pushHudUnderOverlay.call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.visible = true;
      this.overlay.show(PiracyTemplate());
      var corsairs_destroyed = 0;
      for (var i = 0; i < res.anti_piracy_rolls.length; i++) {
        var roll = res.anti_piracy_rolls[i];
        var unittype = res.anti_piracy_unittype[i];
        var faction = res.anti_piracy_faction[i];
        var rrclass = '';
        if (roll >= 5) {
          rrclass = 'hit';
          corsairs_destroyed++;
        }
        var html = "\n                \t\t<div class=\"piracy-row\">\n                \t\t\t<div class=\"piracy-unit\">".concat(unittype, "<div class=\"piracy-desc\">").concat(faction, "</div></div>\n                \t\t\t<div class=\"piracy-roll ").concat(rrclass, "\">").concat(roll, "</div>\n                \t\t</div>\n              \t\t");
        this.app.browser.addElementToSelector(html, '.piracy-grid .attacker');
      }
      for (var _i = 0; _i < res.piracy_rolls.length; _i++) {
        var _roll = res.piracy_rolls[_i];
        var _unittype = res.piracy_unittype[_i];
        var _faction = res.piracy_faction[_i];
        var _rrclass = '';
        if (_roll >= 5) {
          _rrclass = 'hit';
        }
        var _html = "\n                \t\t<div class=\"piracy-row\">\n                \t\t\t<div class=\"piracy-unit\">".concat(_unittype, "<div class=\"piracy-desc\">").concat(_faction, "</div></div>\n                \t\t\t<div class=\"piracy-roll ").concat(_rrclass, "\">").concat(_roll, "</div>\n                \t\t</div>\n              \t\t");
        this.app.browser.addElementToSelector(_html, '.piracy-grid .defender');
      }
      if (corsairs_destroyed == 1) {
        this.updateInstructions("".concat(corsairs_destroyed, " corsair destroyed before Pirate Assault"));
      } else {
        if (corsairs_destroyed > 1) {
          this.updateInstructions("".concat(corsairs_destroyed, " corsairs destroyed before Pirate Assault"));
        }
      }
      this.attachEvents();
    }
  }, {
    key: "updateInstructions",
    value: function updateInstructions() {
      var help = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var x = document.querySelector('.piracy-overlay .help');
      if (x) {
        x.innerHTML = help;
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }]);
}();
module.exports = PiracyOverlay;